// @flow
import { useEffect } from 'react';
import { scroller } from 'react-scroll';
//Components
import { Link, useHistory, useParams } from 'react-router-dom';
import {
  PageLoader,
  PageTitleWithGoBack,
  isRestoringScrollPosition,
} from '../../common';
import { SubdepartmentScroller } from '../../products';
import { subdepartmentSearchUrl } from '../../search';
// Types
import type { Department } from '../types';
// Styles
import './DepartmentPage.css';
//Helpers
import SubDepartmentProductsCards from './SubDepartmentProductsCards';

export type Props = {
  department: Department,
  loading: boolean,
  acessedSubdepartment: String,
};

const DepartmentPage = (props: Props) => {
  const { department, loading } = props;
  const history = useHistory();
  const params = useParams();

  const isStaleData = department && String(department.id) !== String(params.id);

  useEffect(() => {
    if (
      !loading &&
      !isStaleData &&
      department &&
      department.subdepartments?.length === 1
    ) {
      history.replace(
        subdepartmentSearchUrl(
          department.name,
          department.subdepartments[0].name,
        ),
      );
    }
  }, [department, loading, history, isStaleData]);

  useEffect(() => {
    if (
      !props.acessedSubdepartment ||
      !department ||
      isRestoringScrollPosition(history)
    )
      return;

    setTimeout(() => {
      scroller.scrollTo(props.acessedSubdepartment, {
        duration: 800,
        smooth: 'easeInOutQuart',
        offset: -200,
      });
    }, 200);
  }, [props.acessedSubdepartment, department, history]);

  if (props.loading || isStaleData)
    return (
      <div className="department-page-main">
        <PageTitleWithGoBack title="" />
        <PageLoader />
      </div>
    );

  if (!department)
    return (
      <div className="department-not-found">
        <PageTitleWithGoBack title="" />
        <h3>Não foi possível carregar esse departamento.</h3>
        <Link to="/">Voltar ao início</Link>
      </div>
    );

  if (department.viewKind === 'grid') {
    return (
      <div className="department-page-main">
        <PageTitleWithGoBack title={department.name} />
        <div className="department-page-subdepartments">
          {department.subdepartments.map(subdepartment => (
            <SubDepartmentProductsCards
              key={subdepartment.id}
              productIds={subdepartment.products}
              title={subdepartment.name}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="department-page-main">
      <PageTitleWithGoBack title={department.name} />
      {department.subdepartments.map(subdepartment => (
        <SubdepartmentScroller
          key={subdepartment.id}
          subdepartmentId={subdepartment.id}
          title={subdepartment.name}
          productIds={subdepartment.products}
          acessedSubdepartment={props.acessedSubdepartment}
          subdepartmentSlug={subdepartment.slug}
          subdepartmentLink={subdepartmentSearchUrl(
            department.name,
            subdepartment.name,
          )}
        />
      ))}
    </div>
  );
};

export default DepartmentPage;
